import React from "react";
import styles from "./FilterButton.module.scss";
import { getAllClassNames } from "helpers";
//import { Filter } from "assets/icons";
import SvgGenerator, {IconName} from "components/svgGenerator/SvgGenerator";

type IButton = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  disabled?: boolean;
  text: string;
  className?: string;
  replaceClassName?: string;
  color1?: string;
  color2?: string;
  iconName?: IconName;
};

export const FilterButton = ({
  text,
  disabled,
  className,
  replaceClassName,
  color1,
  color2,
  iconName = "Filter",
  ...props
}: IButton) => {
  return (
    <button
      {...props}
      className={getAllClassNames([
        replaceClassName || styles.button,
        disabled && styles.disabled,
        className,
      ])}
      style={
        color1 && color2
          ? {
              backgroundImage: `linear-gradient(to right, ${color1}, ${color2})`,
            }
          : undefined
      }
    >
      {text}
      <SvgGenerator name={iconName} className="filterIcon" objectName="doctorSearchResults" />
    </button>
  );
};
